import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { withStyles, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from "@material-ui/core";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import KeywordsPopover from './KeywordsPopover';

const useStyles = theme => ({
    listItemText: {
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1)
    }
});

const ReportListElement = props => {
    const { classes, id, name, keywords = [], selected, onClick } = props;
    const [anchor, setAnchor] = useState(null);

    const handleKeywordsShow = (e) => setAnchor(e.currentTarget);

    return (
        <React.Fragment>
            <ListItem
                button
                selected={selected}
                onClick={() => onClick(id)}
            >
                <ListItemText
                    className={classes.listItemText}
                >
                    {name}
                </ListItemText>
                <ListItemSecondaryAction>
                    <IconButton
                        onClick={handleKeywordsShow}
                    >
                        <HelpOutlineIcon />
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>
            <KeywordsPopover
                onClose={() => setAnchor(null)}
                anchorEl={anchor}
                keywords={keywords}
            />
        </React.Fragment>
    );
};

ReportListElement.propTypes = {
    classes: PropTypes.object,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    keywords: PropTypes.array,
    selected: PropTypes.bool,
    onClick: PropTypes.func
};

export default withStyles(useStyles)(ReportListElement);
